const endpoint = {
  TRACEABILITY_URL: process.env.REACT_APP_API_TRACEABILITY_URL,
};

export default endpoint;
